import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { ErrorService } from '../../services/error.service';
import { RoutingService } from '../../services/routing.service';

@Component({
  standalone: false,
  selector: 'app-error',
  styleUrls: ['./error.component.scss'],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  public ICONS = ICONS;

  public TranslationKeys = TranslationKeys;

  public constructor(
    private readonly routingService: RoutingService,
    public readonly errorService: ErrorService,
  ) {}

  public copyLink(): void {
    navigator.clipboard.writeText(this.errorService.link);
  }

  public close(): void {
    this.routingService.goToDefaultPage();
  }
}
